import { ChartWidgetType, WIDGET_CONFIG } from '@/components/Metrics/config'
import { WidgetType } from '@/routes/Dashboard/types'

export const isChartWidgetType = (type: WidgetType): type is ChartWidgetType =>
  type in WIDGET_CONFIG
